import React, { useState } from 'react'; // NEW: Import useState
import { BarcodeType1 } from '../types/costwand.d';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table.tsx';
import { Button } from './ui/button.tsx';
import Pagination from './ui/Pagination.tsx'; // Import the new Pagination component
import { Spinner } from './ui/spinner.tsx'; // Import Spinner
import { apiClient } from '../api/apiClient.ts'; // NEW: Import apiClient

interface BarcodeType1TableProps {
  BarcodeType1: BarcodeType1[];
  currentPage: number;
  totalPages: number;
  totalItems: number; // Added totalItems prop
  onPageChange: (page: number) => void;
  onEdit: (barcodeType1: BarcodeType1) => void;
  onDelete: (id: number) => void;
  loading: boolean;
  error: string | null;
  baseEndpoint: string; // NEW: Add baseEndpoint prop
}

const BarcodeType1Table: React.FC<BarcodeType1TableProps> = ({
  BarcodeType1,
  currentPage,
  totalPages,
  totalItems, // Destructure totalItems
  onPageChange,
  onEdit,
  onDelete,
  loading,
  error,
  baseEndpoint, // NEW: Destructure baseEndpoint
}) => {
  const [exportLoading, setExportLoading] = useState(false); // NEW: State for export loading

  const handleExportCsv = async () => {
    setExportLoading(true);
    try {
      await apiClient<void>(baseEndpoint, { downloadCsv: true });
    } catch (err: any) {
      // Error already handled by apiClient and globalErrorHandler
    } finally {
      setExportLoading(false);
    }
  };

  if (loading) return <p className="text-center text-muted-foreground flex items-center justify-center gap-2"><Spinner size="sm" /> Loading Barcode Type 1s...</p>;
  if (error) return <p className="text-center text-destructive">Error: {error}</p>;
  if (BarcodeType1.length === 0 && !loading) return <p className="text-center text-muted-foreground">No Barcode Type 1s found.</p>;

  return (
    <div className="rounded-md border">
      <div className="flex justify-end mb-4"> {/* NEW: Wrapper for export button */}
        <Button onClick={handleExportCsv} disabled={loading || exportLoading} variant="outline">
          {exportLoading ? <span className="flex items-center gap-2"><Spinner size="sm" /> Exporting...</span> : 'Export to CSV'}
        </Button>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Description</TableHead>
            <TableHead>Code</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {BarcodeType1.map((barcodeType1) => (
            <TableRow key={barcodeType1.id}>
              <TableCell className="font-medium">{barcodeType1.description}</TableCell>
              <TableCell>{barcodeType1.code}</TableCell>
              <TableCell className="flex justify-end gap-2">
                <Button variant="outline" size="sm" onClick={() => onEdit(barcodeType1)}>Edit</Button>
                <Button variant="destructive" size="sm" onClick={() => onDelete(barcodeType1.id)}>Delete</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems} // Pass totalItems to Pagination
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default BarcodeType1Table;